<button class="btn btn-primary btn-sm"
        type="button"
        [class.btn-danger]='danger'
        [routerLink]="[href]">
  <i class="{{iconClasses}}"></i>
  {{text}}
</button>
